import { render, staticRenderFns } from "./BaseTooltipButton.vue?vue&type=template&id=7fb66f13&"
import script from "./BaseTooltipButton.vue?vue&type=script&lang=ts&"
export * from "./BaseTooltipButton.vue?vue&type=script&lang=ts&"
import style0 from "./BaseTooltipButton.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
